import { render } from "./ChankangLabel.vue?vue&type=template&id=c87aba62&ts=true"
import script from "./ChankangLabel.vue?vue&type=script&lang=ts"
export * from "./ChankangLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__